import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UserSettingsService } from 'src/app/shared/services/rest/user-settings.service';

@Injectable({
  providedIn: 'root'
})
export class UserSearchTermsService {
  subjectTopic = 'Reservation';
  userSettings: UserSettingsService;

  beforeFormSubmit = new Subject<any>();
  formDataRequest = new Subject<void>();
  formDataResponse = new Subject<any>();
  applyFormData = new Subject<any>();

  constructor(userSettings: UserSettingsService) {
    this.userSettings = userSettings;
  }

  getAllStoredTerms() {
    return this.userSettings.get(`${this.subjectTopic}?filter.Key=~RoomSearchFavorites/*`);
  }

  storeSearchTerms(termsName: string, termsData: any) {
    if (!termsName) { throw new Error('parameter `termsName` is a required value'); }

    // * 'date' field is exempted from user favorites
    delete termsData.date;

    const model = {
      Id: this.subjectTopic,
      Settings: [{ Key: `RoomSearchFavorites/${termsName}`, Value: JSON.stringify(termsData) }]
    };
    return this.userSettings.createSettings(this.subjectTopic, model);
  }

  discardSearchTerms(termsName: string) {
    if (!termsName) { throw new Error('parameter `termsName` is a required value'); }

    return this.userSettings.createSettings(this.subjectTopic, {
      Id: this.subjectTopic,
      Settings: [{ Key: `RoomSearchFavorites/${termsName}`, Value: null }]
    });
  }

  storeLastSearchTerms(termsData: { [x: string]: any; }) {
    const relevantFormFieldKeys = ['location', 'building'];

    const storeModel = relevantFormFieldKeys.reduce((partialModel, currentKey) => {
      return Object.assign(partialModel, { [currentKey]: termsData[currentKey] });
    }, {});

    const model = {
      Id: this.subjectTopic,
      Settings: [{ Key: `RoomLastSearch`, Value: JSON.stringify(storeModel) }]
    };
    return this.userSettings.createSettings(this.subjectTopic, model);
  }

  requestLastSearchTerms() {
    return this.userSettings.get(`${this.subjectTopic}?filter.Key==RoomLastSearch`);
  }
}
